'use client';
import { useAvatars, useRandomAvatar, useUser } from '@/store';
import Image, { ImageProps } from 'next/image';
import React, { useMemo } from 'react';
import styles from './ProfilePicture.module.scss';

type ProfilePictureProps = {
	divProps?: React.HTMLAttributes<HTMLDivElement>;
	imageProps?: Partial<ImageProps>;
	isGlowing?: boolean;
	selectedAvatarId?: number | null;
};

const ProfilePicture = ({
	divProps,
	imageProps,
	isGlowing,
	selectedAvatarId = null,
}: ProfilePictureProps) => {
	const avatars = useAvatars();
	const user = useUser();
	const randomAvatar = useRandomAvatar();

	const profilePictureToShow = useMemo(() => {
		if (!avatars) return undefined;

		if (selectedAvatarId || selectedAvatarId === 0) {
			const avatar = avatars?.find((a) => a.id === selectedAvatarId);
			return avatar?.avatar_url;
		}

		if (user) {
			if (user.avatarId) {
				const avatar = avatars?.find((a) => a.id === user.avatarId);
				return avatar?.avatar_url;
			}
			return randomAvatar?.avatar_url;

			// if (avatars && avatars.length > 0) {
			// 	const randomIndex = Math.floor(Math.random() * avatars.length);
			// 	return avatars[randomIndex]?.avatar_url;
			// }
		}
		return undefined;
	}, [avatars, user, randomAvatar, selectedAvatarId]);

	return (
		<div
			{...divProps}
			className={`${styles.profilePicture} rounded-full h-full w-full  relative ${divProps?.className ?? ''}`}
			data-glowing={isGlowing}
		>
			{profilePictureToShow ? (
				<Image
					src={profilePictureToShow}
					alt="avatar"
					fill
					className={`object-cover ${imageProps?.className ?? ''}`}
					{...imageProps}
				/>
			) : (
				<Image
					src="https://avatars.githubusercontent.com/u/103980177?v=4"
					alt="avatar"
					fill
					className={`rounded-full ${imageProps?.className ?? ''}`}
					{...imageProps}
				/>
			)}
		</div>
	);
};

export default ProfilePicture;
